export default {
  props: {
    detail: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      texts: ["非常差", "差", "一般", "好", "非常好"],
      colors: ["#fe5301", "#fe5301", "#fe5301"],
    };
  },
  methods: {
    rateChange(val, name) {
      const { detail } = this;
      detail[name] = val;

      this.$emit(`update:detail`, detail);
    },
  },
};
